var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/context.ts
import * as React from "react";
var i18nInstance = null;
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var I18nContext = React.createContext({
  i18n: void 0,
  locale: void 0
});
var registerReactInstance = {
  type: "intl3rdParty",
  init(instance) {
    setI18n(instance);
  }
};
var defaultOptions = {
  bindI18n: "languageChanged loaded initialized",
  bindI18nStore: "added",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: true,
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: true
};
function getDefaults() {
  return defaultOptions;
}

// src/index.ts
import { createElement as createElement3 } from "react";

// src/lib/Provider.ts
import * as React2 from "react";
import { I18n } from "@ies/starling_intl";
var EVENT_NAME = /* @__PURE__ */ ((EVENT_NAME2) => {
  EVENT_NAME2["languageChanged"] = "languageChanged";
  EVENT_NAME2["loaded"] = "loaded";
  EVENT_NAME2["initialized"] = "initialized";
  return EVENT_NAME2;
})(EVENT_NAME || {});
var STORE_EVENT_NAME = /* @__PURE__ */ ((STORE_EVENT_NAME2) => {
  STORE_EVENT_NAME2["added"] = "added";
  return STORE_EVENT_NAME2;
})(STORE_EVENT_NAME || {});
function IntlProvider(props) {
  const [_flag, setRefreshFlag] = React2.useState(false);
  const onInstanceChange = React2.useCallback(
    (type) => {
      setRefreshFlag((prev) => !prev);
    },
    []
  );
  const i18n = props.i18n || getI18n() || I18n;
  const nowLocale = props.locale || (i18n || {}).i18nInstance.instance.language || void 0;
  React2.useEffect(() => {
    if (!i18n) {
      return;
    }
    const coreInstance = i18n.i18nInstance.instance;
    Object.keys(EVENT_NAME).forEach((event) => {
      coreInstance.on(
        event,
        () => onInstanceChange(event)
      );
    });
    Object.keys(STORE_EVENT_NAME).forEach((event) => {
      coreInstance.store.on(
        event,
        () => onInstanceChange(event)
      );
    });
    return () => {
      Object.keys(EVENT_NAME).forEach((event) => {
        coreInstance.off(event);
      });
      Object.keys(STORE_EVENT_NAME).forEach((event) => {
        coreInstance.store.off(event);
      });
    };
  }, [i18n]);
  const value = React2.useMemo(
    () => ({
      i18n,
      locale: nowLocale || I18n.i18nInstance.instance.language
    }),
    [i18n, nowLocale, _flag]
  );
  return React2.createElement(I18nContext.Provider, { value }, props.children);
}

// src/lib/Trans.ts
import React3, { useContext } from "react";
import HTML from "html-parse-stringify2";

// src/lib/utils.ts
function warn(...args) {
  if (console && console.warn) {
    if (typeof args[0] === "string")
      args[0] = `react-i18next:: ${args[0]}`;
    console.warn(...args);
  }
}
var alreadyWarned = {};
function warnOnce(...args) {
  if (typeof args[0] === "string" && alreadyWarned[args[0]])
    return;
  if (typeof args[0] === "string")
    alreadyWarned[args[0]] = /* @__PURE__ */ new Date();
  warn(...args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, () => {
    if (i18n.isInitialized) {
      cb();
    } else {
      const initialized = () => {
        setTimeout(() => {
          i18n.off("initialized", initialized);
        }, 0);
        cb();
      };
      i18n.on("initialized", initialized);
    }
  });
}
function hasLoadedNamespace(ns, i18n, options = {}) {
  if (!i18n.languages || !i18n.languages.length) {
    console.warn("i18n.languages were undefined or empty", i18n.languages);
    return true;
  }
  const lng = i18n.languages[0];
  const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  const lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === "cimode")
    return true;
  const loadNotPending = (l, n) => {
    const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
    return loadState === -1 || loadState === 2;
  };
  if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns))
    return false;
  if (i18n.hasResourceBundle(lng, ns))
    return true;
  if (!i18n.services.backendConnector.backend)
    return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns)))
    return true;
  return false;
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}

// src/lib/Trans.ts
function hasChildren(node, checkLength) {
  if (!node)
    return false;
  const base = node.props ? node.props.children : node.children;
  if (checkLength)
    return base.length > 0;
  return !!base;
}
function getChildren(node) {
  if (!node)
    return [];
  return node && node.children ? node.children : node.props && node.props.children;
}
function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== "[object Array]")
    return false;
  return children.every((child) => React3.isValidElement(child));
}
function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}
function mergeProps(source, target) {
  const newTarget = __spreadValues({}, target);
  newTarget.props = Object.assign(source.props, target.props);
  return newTarget;
}
function nodesToString(children, i18nOptions) {
  if (!children)
    return "";
  let stringNode = "";
  const childrenArray = getAsArray(children);
  const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  childrenArray.forEach((child, childIndex) => {
    if (typeof child === "string") {
      stringNode += `${child}`;
    } else if (React3.isValidElement(child)) {
      const props = child.props;
      const childPropsCount = Object.keys(props).length;
      const shouldKeepChild = keepArray.indexOf(child.type) > -1;
      const childChildren = props.children;
      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
        stringNode += `<${child.type}/>`;
      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
        stringNode += `<${childIndex}></${childIndex}>`;
      } else if (props.i18nIsDynamicList) {
        stringNode += `<${childIndex}></${childIndex}>`;
      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") {
        stringNode += `<${child.type}>${childChildren}</${child.type}>`;
      } else {
        const content = nodesToString(childChildren, i18nOptions);
        stringNode += `<${childIndex}>${content}</${childIndex}>`;
      }
    } else if (child === null) {
      warn(
        `Trans: the passed in value is invalid - seems you passed in a null child.`
      );
    } else if (typeof child === "object") {
      const _a = child, { format } = _a, clone = __objRest(_a, ["format"]);
      const keys = Object.keys(clone);
      if (keys.length === 1) {
        const value = format ? `${keys[0]}, ${format}` : keys[0];
        stringNode += `{{${value}}}`;
      } else {
        warn(
          `react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`,
          child
        );
      }
    } else {
      warn(
        `Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`,
        child
      );
    }
  });
  return stringNode;
}
function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts) {
  if (targetString === "")
    return [];
  const i18next = i18n.i18nInstance.instance;
  const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join("|")).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling)
    return [targetString];
  const data = {};
  function getData(childs) {
    const childrenArray = getAsArray(childs);
    childrenArray.forEach((child) => {
      if (typeof child === "string")
        return;
      if (hasChildren(child))
        getData(getChildren(child));
      else if (typeof child === "object" && !React3.isValidElement(child))
        Object.assign(data, child);
    });
  }
  getData(children);
  const ast = HTML.parse(`<0>${targetString}</0>`);
  const opts = __spreadValues(__spreadValues({}, data), combinedTOpts);
  function renderInner(child, node, rootReactNode) {
    const childs = getChildren(child);
    const mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
  }
  function pushTranslatedJSX(child, inner, mem, i, isVoid) {
    if (child.dummy)
      child.children = inner;
    mem.push(
      React3.cloneElement(
        child,
        __spreadProps(__spreadValues({}, child.props), { key: i }),
        isVoid ? void 0 : inner
      )
    );
  }
  function mapAST(reactNode, astNode, rootReactNode) {
    const reactNodes = getAsArray(reactNode);
    const astNodes = getAsArray(astNode);
    return astNodes.reduce((mem, node, i) => {
      const translationContent = node.children && node.children[0] && node.children[0].content && i18next.services.interpolator.interpolate(
        node.children[0].content,
        opts,
        i18n.language
      );
      if (node.type === "tag") {
        let tmp = reactNodes[parseInt(node.name, 10)];
        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name])
          tmp = rootReactNode[0][node.name];
        if (!tmp)
          tmp = {};
        const child = Object.keys(node.attrs).length !== 0 ? mergeProps({ props: node.attrs }, tmp) : tmp;
        const isElement = React3.isValidElement(child);
        const isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
        const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === "object" && child.dummy && !isElement;
        const isKnownComponent = typeof children === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
        if (typeof child === "string") {
          const value = i18next.services.interpolator.interpolate(
            child,
            opts,
            i18n.language
          );
          mem.push(value);
        } else if (hasChildren(child) || // the jsx element has children -> loop
        isValidTranslationWithChildren) {
          const inner = renderInner(child, node, rootReactNode);
          pushTranslatedJSX(child, inner, mem, i);
        } else if (isEmptyTransWithHTML) {
          const inner = mapAST(
            reactNodes,
            node.children,
            rootReactNode
          );
          mem.push(
            React3.cloneElement(child, __spreadProps(__spreadValues({}, child.props), { key: i }), inner)
          );
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            const inner = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, inner, mem, i, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push(
                React3.createElement(node.name, { key: `${node.name}-${i}` })
              );
            } else {
              const inner = mapAST(
                reactNodes,
                node.children,
                rootReactNode
              );
              mem.push(
                React3.createElement(
                  node.name,
                  { key: `${node.name}-${i}` },
                  inner
                )
              );
            }
          } else if (node.voidElement) {
            mem.push(`<${node.name} />`);
          } else {
            const inner = mapAST(
              reactNodes,
              node.children,
              rootReactNode
            );
            mem.push(`<${node.name}>${inner}</${node.name}>`);
          }
        } else if (typeof child === "object" && !isElement) {
          const content = node.children[0] ? translationContent : null;
          if (content)
            mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          mem.push(
            React3.cloneElement(
              child,
              __spreadProps(__spreadValues({}, child.props), { key: i }),
              translationContent
            )
          );
        } else {
          mem.push(React3.cloneElement(child, __spreadProps(__spreadValues({}, child.props), { key: i })));
        }
      } else if (node.type === "text") {
        const wrapTextNodes = i18nOptions.transWrapTextNodes;
        const content = i18next.services.interpolator.interpolate(
          node.content,
          opts,
          i18n.language
        );
        if (wrapTextNodes) {
          mem.push(
            React3.createElement(
              wrapTextNodes,
              { key: `${node.name}-${i}` },
              content
            )
          );
        } else {
          mem.push(content);
        }
      }
      return mem;
    }, []);
  }
  const result = mapAST(
    [{ dummy: true, children: children || [] }],
    ast,
    getAsArray(children || [])
  );
  return getChildren(result[0]);
}
function handleICUTagConflict(str) {
  try {
    const astRoot = HTML.parse(`<0>${str}</0>`);
    const res = [];
    (function process(nodes) {
      nodes.forEach((item) => {
        if (item.type === "text") {
          return res.push(item);
        }
        res.push({ type: "text", content: `'<${item.name}'>` });
        process(item.children || []);
        res.push({ type: "text", content: `'</${item.name}'>` });
      });
    })((astRoot[0] || {}).children || []);
    astRoot[0].children = res;
    return HTML.stringify(astRoot).split(/^<0>(.+)<\/0>$/)[1];
  } catch (err) {
    return str;
  }
}
function Trans(_a) {
  var _b = _a, {
    children,
    count,
    parent,
    i18nKey,
    tOptions = {},
    values,
    defaults,
    components,
    ns,
    i18n: i18nFromProps,
    t: tFromProps,
    autoHandleConflict
  } = _b, additionalProps = __objRest(_b, [
    "children",
    "count",
    "parent",
    "i18nKey",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "autoHandleConflict"
  ]);
  var _a2, _b2, _c, _d;
  const { i18n: i18nFromContext } = useContext(I18nContext) || {};
  const i18n = i18nFromProps || i18nFromContext || getI18n();
  if (!i18n) {
    warnOnce(
      "You will need to pass in an i18next instance by using i18nextReactModule"
    );
    return children;
  }
  const t = tFromProps || i18n.t.bind(i18n) || ((k) => k);
  const reactI18nextOptions = __spreadValues(__spreadValues({}, getDefaults()), ((_b2 = (_a2 = i18n == null ? void 0 : i18n.i18nInstance) == null ? void 0 : _a2.config) == null ? void 0 : _b2.react) || {});
  let namespaces = ns || t.ns || ((_d = (_c = i18n == null ? void 0 : i18n.i18nInstance) == null ? void 0 : _c.config) == null ? void 0 : _d.defaultNS);
  namespaces = typeof namespaces === "string" ? [namespaces] : namespaces || ["translation"];
  const defaultValue = defaults || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  const { hashTransKey } = reactI18nextOptions;
  const key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  const interpolationOverride = values ? tOptions.interpolation : (
    // : { interpolation: { ...tOptions.interpolation, prefix: '#$?', suffix: '?$#' } };
    {
      interpolation: __spreadProps(__spreadValues({}, tOptions.interpolation), { prefix: "{", suffix: "}" })
    }
  );
  const combinedTOpts = __spreadProps(__spreadValues(__spreadValues(__spreadProps(__spreadValues({}, tOptions), {
    count
  }), values), interpolationOverride), {
    defaultValue,
    ns: namespaces
  });
  let translation = defaultValue;
  if (!!key) {
    if (!!autoHandleConflict) {
      try {
        const resource = i18n.i18nInstance.instance.getResource(
          i18n.language,
          namespaces[0] || "translation",
          key
        );
        if (!resource) {
          throw new Error();
        }
        const noConflictTranslation = handleICUTagConflict(resource);
        translation = i18n.i18nInstance.instance.services.i18nFormat.parse(
          noConflictTranslation,
          combinedTOpts,
          i18n.language,
          namespaces[0] || "translation",
          key
        );
      } catch (err) {
        translation = t(key, combinedTOpts);
      }
    } else {
      translation = t(key, combinedTOpts);
    }
  }
  const content = renderNodes(
    components || children,
    translation,
    i18n,
    reactI18nextOptions,
    combinedTOpts
  );
  const useAsParent = parent !== void 0 ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? React3.createElement(useAsParent, additionalProps, content) : content;
}

// src/lib/useTranslation.ts
import * as React4 from "react";
function useTranslation(ns, props = {}) {
  const { i18n: i18nFromProps } = props;
  const { i18n: i18nFromContext } = React4.useContext(I18nContext) || {};
  const i18n = i18nFromProps || i18nFromContext || getI18n() || void 0;
  if (!i18n) {
    console.warn(
      "You will need to pass in an @ies/starling_intl instance by using registerReactInstance"
    );
    const notReadyT = (k) => Array.isArray(k) ? k[k.length - 1] : k;
    const retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }
  const coreInstance = i18n.i18nInstance.instance;
  if (coreInstance.options.react && coreInstance.options.react.wait !== void 0) {
    console.warn(
      "It seems you are still using the old wait option, you may migrate to the new useSuspense behavior."
    );
  }
  const i18nOptions = __spreadValues(__spreadValues(__spreadValues({}, getDefaults()), coreInstance.options.react), props);
  const { useSuspense } = i18nOptions;
  let namespaces = ns || coreInstance.options && coreInstance.options.defaultNS || [];
  namespaces = typeof namespaces === "string" ? [namespaces] : namespaces || ["translation"];
  const ready = (coreInstance.isInitialized || coreInstance.initializedStoreOnce) && namespaces.every(
    (n) => hasLoadedNamespace(n, coreInstance, i18nOptions)
  );
  function getT() {
    return {
      // t: coreInstance.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0]),
      // todo:: get fixed t
      t: (...args) => {
        if (!Array.isArray(args))
          return "";
        let [keys, options = {}, fallbackText] = args;
        if (Array.isArray(namespaces) && !!namespaces.filter((i) => !!i).length) {
          options.ns = namespaces;
        }
        return i18n.t(keys, options, fallbackText);
      }
    };
  }
  const [t, setT] = React4.useState(getT());
  const isMounted = React4.useRef(true);
  React4.useEffect(() => {
    const { bindI18n, bindI18nStore } = i18nOptions;
    isMounted.current = true;
    if (!ready && !useSuspense) {
      loadNamespaces(coreInstance, namespaces, () => {
        if (isMounted.current)
          setT(getT());
      });
    }
    function boundReset() {
      if (isMounted.current)
        setT(getT());
    }
    const bindI18nEvents = !!bindI18n ? bindI18n.split(" ").filter((i) => !!i) : "";
    const bindI18nStoreEvents = !!bindI18nStore ? bindI18nStore.split(" ").filter((i) => !!i) : "";
    if (bindI18nEvents && coreInstance) {
      bindI18nEvents.forEach((e) => coreInstance.on(e, boundReset));
    }
    if (bindI18nStoreEvents && coreInstance) {
      bindI18nStoreEvents.forEach((e) => coreInstance.store.on(e, boundReset));
    }
    return () => {
      isMounted.current = false;
      if (bindI18nEvents && coreInstance)
        bindI18nEvents.forEach((e) => coreInstance.off(e, boundReset));
      if (bindI18nStoreEvents && coreInstance)
        bindI18nStoreEvents.forEach((e) => coreInstance.store.off(e, boundReset));
    };
  }, [coreInstance, namespaces.join()]);
  const isInitial = React4.useRef(true);
  React4.useEffect(() => {
    if (isMounted.current && !isInitial.current) {
      setT(getT());
    }
    isInitial.current = false;
  }, [coreInstance]);
  const ret = [t.t, i18n, ready];
  ret.t = t.t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready)
    return ret;
  if (!ready && !useSuspense)
    return ret;
  throw new Promise((resolve) => {
    loadNamespaces(coreInstance, namespaces, () => {
      resolve();
    });
  });
}

// src/lib/withTranslation.ts
import * as React5 from "react";
function withTranslation(ns, options = {}) {
  return function Extend(WrappedComponent) {
    function I18nextWithTranslation(_a) {
      var _b = _a, { forwardedRef } = _b, rest = __objRest(_b, ["forwardedRef"]);
      const [t, i18n, ready] = useTranslation(ns, rest);
      const passDownProps = __spreadProps(__spreadValues({}, rest), {
        t,
        i18n,
        tReady: ready
      });
      if (options.withRef && forwardedRef) {
        passDownProps.ref = forwardedRef;
      } else if (!options.withRef && forwardedRef) {
        passDownProps.forwardedRef = forwardedRef;
      }
      return React5.createElement(WrappedComponent, passDownProps);
    }
    I18nextWithTranslation.displayName = `withI18nextTranslation(${getDisplayName(
      WrappedComponent
    )})`;
    I18nextWithTranslation.WrappedComponent = WrappedComponent;
    const forwardRef2 = (props, ref) => React5.createElement(
      I18nextWithTranslation,
      Object.assign({}, props, { forwardedRef: ref })
    );
    return options.withRef ? React5.forwardRef(forwardRef2) : I18nextWithTranslation;
  };
}

// src/index.ts
function getHtml(keys, options, fallbackText) {
  const i18n = getI18n() || { t: (...args) => args[0] };
  const t = i18n.t;
  return createElement3("span", {
    dangerouslySetInnerHTML: {
      __html: t ? t(keys, options, fallbackText) : keys
    }
  });
}
export {
  I18nContext,
  IntlProvider,
  Trans,
  getHtml,
  registerReactInstance,
  useTranslation,
  withTranslation
};
